import React, { useState, useEffect, useRef } from "react";

import { getShopNoticeList } from "../../api";

import { recommendParamsFilter } from "../../utils";


import Pager from "../Pager";
import Placeholder from "../Placeholder";

import Notice from "../Notice";


import styles from "./NoticeList.module.css";

const PAGESIZE = 8;
interface NoticeProps {
  venderId: Number;
}
const NoticeList: React.FC<NoticeProps> = props => {
  const { venderId } = props

  const containerRef = useRef<HTMLDivElement>(null);
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const [empty, setEmtpy] = useState(false);

  const fetchData = (current?: number) => {
    const params: any = {
      vendorId:venderId,
      pageNo: current || 1,
      pageSize: PAGESIZE,
      publishSource: 10,
    
    };
    getShopNoticeList(recommendParamsFilter(params)).then(res => {
      console.log("res=",res)
      let { data, totalItem} = res
      setList(data || []);
      setTotal(totalItem || 0);
      setEmtpy(!totalItem);
    });
  }

  useEffect(() => {
    setPage(1);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    venderId
  ]);

  useEffect(() => {
    const target = containerRef.current as HTMLDivElement;
    const currentTop = target.getBoundingClientRect().top;
    const top = target.offsetTop - 51;
    if (currentTop < 0) {
      window.scrollTo(0, top);
    }
  }, [page]);

  return (
    <div className={styles.container} ref={containerRef}>
      {empty ? (
        <Placeholder text="暂无相关公告，敬请期待～" />
      ) : (
        <div className={styles.list}>
          {list.map((item:any, index) => {
            return <Notice key={index} {...item} />;
          })}
        </div>
      )}
      <Pager
        current={page}
        pageSize={PAGESIZE}
        handler={current => {
          setPage(current);
          fetchData(current);
        }}
        total={total}
      />
    </div>
  );
}

export default NoticeList;
